'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactRouterBootstrap = require('react-router-bootstrap');

var _Navbar = require('react-bootstrap/lib/Navbar');

var _Navbar2 = _interopRequireDefault(_Navbar);

var _Nav = require('react-bootstrap/lib/Nav');

var _Nav2 = _interopRequireDefault(_Nav);

var _NavItem = require('react-bootstrap/lib/NavItem');

var _NavItem2 = _interopRequireDefault(_NavItem);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App() {
    (0, _classCallCheck3.default)(this, App);
    return (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).apply(this, arguments));
  }

  (0, _createClass3.default)(App, [{
    key: 'render',
    value: function render() {
      var styles = require('./App.scss');

      return _react2.default.createElement(
        'div',
        { className: styles.app },
        _react2.default.createElement(_reactHelmet2.default, _config2.default.app.head),
        _react2.default.createElement(
          _Navbar2.default /* fixedTop */,
          { className: styles.navbar, collapseOnSelect: true },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              _Navbar2.default.Header,
              null,
              _react2.default.createElement(
                _Navbar2.default.Brand,
                null,
                _react2.default.createElement(
                  _reactRouter.IndexLink,
                  { to: '/', 'aria-label': 'Nenud\xEDm se', title: 'Nenud\xEDm se' },
                  _react2.default.createElement(
                    'div',
                    { className: styles.brand },
                    _react2.default.createElement(
                      'svg',
                      {
                        xmlns: 'http://www.w3.org/2000/svg',
                        width: '160',
                        height: '40',
                        viewBox: '0 0 396 100'
                      },
                      _react2.default.createElement('rect', { width: '100', height: '100', fill: 'none' }),
                      _react2.default.createElement(
                        'g',
                        { className: 'currentLayer' },
                        _react2.default.createElement('title', null),
                        _react2.default.createElement(
                          'g',
                          { className: 'selected' },
                          _react2.default.createElement('path', {
                            d: 'M224.2 26.7C224.2 28.9 224.2 29.7 224.3 28.6 224.4 27.4 224.4 25.6 224.3 24.6 224.2 23.5 224.2 24.5 224.2 26.7',
                            fill: '#393939'
                          }),
                          _react2.default.createElement('path', {
                            d: 'M234.5 20.9C234.5 21.7 234.6 22 234.7 21.6 234.8 21.2 234.8 20.6 234.7 20.2 234.6 19.8 234.5 20.1 234.5 20.9M224.1 21.5C224.1 22.4 224.2 22.7 224.3 22.2 224.4 21.7 224.4 21 224.3 20.6 224.2 20.2 224.1 20.6 224.1 21.5M101.8 45.9C101.8 47.9 101.8 48.7 101.9 47.8 102 46.9 102 45.2 101.9 44.2 101.8 43.1 101.8 43.9 101.8 45.9M155.7 44.3C155.7 45.2 155.8 45.5 155.9 45 156 44.5 156 43.8 155.9 43.4 155.8 43 155.7 43.4 155.7 44.3M234.9 59.9C235 61.6 235 62.3 235.1 61.4 235.2 60.4 235.2 59 235.1 58.2 235 57.4 234.9 58.1 234.9 59.9',
                            fill: '#5f5f5f'
                          }),
                          _react2.default.createElement('path', {
                            d: 'M222 0.3C216.4 2.1 217.4 10.5 223.1 10.5 223.8 10.5 223.9 11 224.1 17.7 224.6 30.5 224.6 31.4 223.5 31.1 206.6 26.3 192.8 37.4 192.8 55.8L192.8 58.8 194.1 58.5C195.8 58 199 58.7 200.4 59.9 204 62.9 204.3 66.6 201.4 73.4 201.2 74 201.6 74.3 203.8 75.3 209 77.8 216.3 77.3 222.6 74.1 226.2 72.2 226 72.2 226 73.4 226 78.2 234.2 80.6 238.5 76.9 242.3 73.7 241.1 66.4 236.4 64.5 234.8 63.8 234.9 64.9 234.7 36L234.5 10.6 236.5 10.4C241.4 9.9 242.6 2.7 238.1 1 237 0.5 223.1 0 222 0.3M253.5 8.3C242.6 18.2 241.6 20.4 246.4 22.9 249.9 24.8 251.1 24.1 260.4 15 263.2 12.2 263.6 10.4 261.5 8.2 258.9 5.3 256.8 5.4 253.5 8.3M6.8 27C1 29.1 0 36.6 5.1 39.1L6.8 39.9 6.8 53.7 6.8 67.5 4.8 68.2C1.6 69.3 0.2 73.1 2.1 75.5 4.6 78.7 18.6 78.3 21.2 75 22.9 72.8 22.2 69.9 19.4 68.3L17.6 67.2 17.6 53.4 17.6 39.6 19.5 38.8C28.9 34.6 33.4 42.1 33.1 61L33 67.5 30.7 68.6C28.2 69.8 27.6 70.5 27.6 72.7 27.6 77 35 78.8 44.6 76.8 50.5 75.5 50.9 68.7 45 67.9L43.3 67.6 43.3 59.7C43.4 36.7 37.2 26.3 24.1 27.1 21.8 27.3 17.9 28.2 16.2 29 15.4 29.3 15.1 29.3 14.3 28.6 12.3 26.7 9.4 26.1 6.8 27M101 27.3C95.7 29.8 95.2 37.6 100.3 39.3 101.8 39.8 102 40.5 101.8 46.5 101.8 49 101.7 54.8 101.7 59.3L101.6 67.5 99.7 68.2C96.5 69.3 95 73.5 97 75.7 99.7 78.6 113.1 78.2 116 75.1 117.9 73 117 69.7 114 68L112.4 67.1 112.4 53.4 112.4 39.8 114.3 38.8C122.9 34.7 127.7 41.2 128 57.6L128.1 61.3 129.4 60.1C131.1 58.7 134 58 136.2 58.5 137.1 58.7 138 58.9 138.1 58.9 139.1 58.9 137.6 45.6 136.1 40.5 132.9 29.4 124.3 24.8 113.3 28.3L109.9 29.3 108.9 28.3C106.8 26.3 103.8 25.9 101 27.3M176.2 26.9C168.3 28.1 167.3 34.7 174.5 37.3L175.6 37.7 175.6 44C175.4 60.5 172.4 66.5 164.4 66.5 158.2 66.5 155.5 57.9 155.9 40L156 36.9 157.4 36.9C162.6 36.9 164 30.3 159.2 27.9 157.9 27.3 148.2 27 144.4 27.5 138 28.4 137.5 37.2 143.8 37.8L145 37.9 145.3 45.1C146.1 67.4 152.7 77.5 165.8 76.8 179 76 185.3 66.4 185.9 45.7L186.2 37.2 188 36.5C192.8 34.6 192.9 29.7 188.1 27.6 186.1 26.7 179.6 26.3 176.2 26.9M250 27.7C244.1 29.7 243 37.4 248.3 39.8L249.3 40.3 249.1 51.9C248.9 58.3 248.8 64.3 248.8 65.3L248.8 67.2 247 67.6C242.1 68.9 241.1 74.3 245.3 76.6 248.5 78.2 260.7 77.9 263.8 76.2 267.5 74 266.3 68.8 261.8 67.6L260 67.1 260 50.9C260 33.1 259.9 31.8 257.7 29.2 255.7 26.9 253.6 26.4 250 27.7M64.9 27.8C52.5 30.9 45.6 45.9 49.6 61.1 53.3 75.1 64.3 81.3 76.6 76.2 78.9 75.3 80 74.5 84.2 71.2 85.5 70.1 85.6 70 86.6 70.7 92 74.2 95.6 67.3 90.9 62.5 82 53.7 73.3 55 77.4 64.5 78 66 73.3 68.9 70.3 68.9 64.1 68.9 59.4 64.1 58.6 57L58.3 54.6 67.5 54.3C82.6 53.8 84.1 53.7 85.1 53.1 86.5 52.1 87.6 49.5 87.6 46.8 87.7 34.1 76.7 24.9 64.9 27.8M288.2 28.2C286 29 284.4 29.8 283 31.1 282 32.1 281.9 32.1 281.5 31.4 280.1 28.9 276.3 27.6 272.7 28.4 266.2 29.9 265.6 38.6 272 39.2L273.9 39.4 274.2 44C274.8 52.5 274.2 68.6 273.4 69.1 269.5 71.3 268.8 75.8 272.1 77.5 273.5 78.2 284.2 78.3 286.4 77.5 290.2 76.3 289.9 69.3 286.1 69L284.7 68.8 284.9 57.8C285.1 46.9 285.3 45.1 286.7 42.1 288.8 37.2 295.7 37.4 297.9 42.4 298.9 44.7 299.6 52 299.6 59.5 299.6 68.1 299.6 68 297.3 69.5 294 71.6 294.1 74.2 297.4 76.7 298.9 77.8 308.4 78.1 311.1 77.1 315.9 75.2 315.5 70.1 310.3 67.9L309.2 67.4 309.3 57.5C309.5 44.9 310.5 41.1 314.1 39.1 319.5 36.2 322.4 43.1 323 59.7L323.3 67.5 321.8 68.3C319.5 69.5 318.4 71.1 318.4 73 318.4 76.6 320.3 77.7 327 78 336.3 78.4 339.1 76.9 338.9 71.9 338.8 70.6 335.7 67.3 334.6 67.3 333.7 67.3 333.4 65.9 333.3 61.3 333 48 330.5 37.6 326.2 32.5 321.5 26.8 313.7 26.4 307.3 31.6L305.1 33.3 303.6 31.8C300 28.3 293 26.6 288.2 28.2M74.2 37.6C75.8 38.7 77 40.6 77.4 42.7 77.8 44.4 77.4 44.5 67.3 44.8L59.1 45 60.4 42.6C63.3 36.8 69.8 34.5 74.2 37.6M219.1 40.3C220.2 40.7 221.7 41.5 222.5 42L224 43.1 224 52.5C224 63.4 224.3 62.7 219.5 64.9 210.3 69 203.3 65.3 202.9 56 202.4 45.1 210.4 37.4 219.1 40.3M125.4 68.5C119.8 70.8 122.1 76.7 128.9 77.5 131.1 77.7 131.1 77.9 129.8 75.5 129.2 74.5 128.3 72.4 127.8 71 126.8 68.1 126.6 68 125.4 68.5',
                            fill: '#626262'
                          }),
                          _react2.default.createElement('path', {
                            d: 'M192.6 79.8C190.1 83.1 183.6 88 179.3 89.7 177.7 90.3 177.7 90 179.8 93.3 183.4 98.9 187.8 100.2 193 97.1 199.9 93.1 200.8 88.8 196.2 81.5 193.9 77.7 194 77.8 192.6 79.8',
                            fill: '#f44336'
                          }),
                          _react2.default.createElement('path', {
                            d: 'M362.1 37.4L360.6 38.8 358.6 38.3C351.7 36.2 344.8 40.2 344.8 46.4 344.8 51.4 347.9 53.7 355.6 54.3 360.9 54.7 362.6 57.1 359.8 60.4 356.8 64 349.7 62.2 350.3 57.9 351 52.5 345.9 53.9 343.1 59.8 341 64.2 343 67.9 346.2 65.6 346.8 65.1 347.3 65.3 349.7 66.5 358.1 70.6 366.8 66.1 366.8 57.5 366.8 51.7 364.1 49.3 357.1 48.9 352.4 48.6 350.8 47.9 350.8 46.3 350.8 43.2 358.5 42.5 359.8 45.5 361.6 49.9 366.7 45.9 367.1 39.7 367.4 36.1 364.9 34.9 362.1 37.4M376.2 39C368.9 42.4 366.2 53.2 370.4 62 373.9 69.1 382.9 70.6 389.2 65 390.3 64 390.8 63.8 391.3 64.1 393.5 65.3 396.1 63.1 395.2 60.9 392.9 55.3 383.4 53.6 385.2 59.1 386.3 62.4 381.6 64 377.8 61.7 376.2 60.7 375.1 58.7 374.6 56L374.3 54.6 377.1 54.3C378.6 54.2 382 54.1 384.7 54.1 391.2 54.1 391.8 53.6 391.8 49.2 391.8 40.8 383.7 35.5 376.2 39M383.9 44.4C386.2 46.3 386.3 47.9 384.1 48.2 381.9 48.5 375.2 48.6 375.2 48.3 375.2 44.8 381.2 42.1 383.9 44.4M131.7 63.5C128.4 66.9 135.4 79.9 143.8 85.9 162.2 99 187.8 92.5 197.3 72.3 200.3 65.8 199.7 62.5 195.5 62.5 193.4 62.5 192.4 63.4 191.6 65.9 183.8 90.7 148.8 91.5 138.9 67.1 136.9 62.3 134.3 61 131.7 63.5',
                            fill: '#ffc107'
                          })
                        )
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(_Navbar2.default.Toggle, null)
            ),
            _react2.default.createElement(
              _Navbar2.default.Collapse,
              { ref: 'navbarCollapse', eventKey: 0 },
              _react2.default.createElement(
                _Nav2.default,
                { pullRight: true },
                _react2.default.createElement(
                  _reactRouterBootstrap.LinkContainer,
                  { className: 'green', to: '/detske-tabory' },
                  _react2.default.createElement(
                    _NavItem2.default,
                    { title: 'Letn\xED d\u011Btsk\xE9 t\xE1bory', eventKey: 1 },
                    'D\u011Btsk\xE9 t\xE1bory'
                  )
                ),
                _react2.default.createElement(
                  _reactRouterBootstrap.LinkContainer,
                  { className: 'light-blue', to: '/sportovni-pripravka' },
                  _react2.default.createElement(
                    _NavItem2.default,
                    { title: 'Celoro\u010Dn\xED sportovn\xED p\u0159\xEDpravka', eventKey: 3 },
                    'Sportovn\xED p\u0159\xEDpravka'
                  )
                ),
                _react2.default.createElement(
                  _reactRouterBootstrap.LinkContainer,
                  { className: 'dark-blue', to: '/kondicni-priprava' },
                  _react2.default.createElement(
                    _NavItem2.default,
                    {
                      title: 'Kondi\u010Dn\xED p\u0159\xEDprava v mal\xFDch skupink\xE1ch',
                      eventKey: 4
                    },
                    'Kondi\u010Dn\xED p\u0159\xEDprava'
                  )
                ),
                _react2.default.createElement(
                  _reactRouterBootstrap.LinkContainer,
                  { className: 'violet', to: '/nas-tym' },
                  _react2.default.createElement(
                    _NavItem2.default,
                    { title: 'N\xE1\u0161 t\xFDm', eventKey: 5 },
                    'N\xE1\u0161 t\xFDm'
                  )
                ),
                _react2.default.createElement(
                  _reactRouterBootstrap.LinkContainer,
                  { className: 'red', to: '/kontakty' },
                  _react2.default.createElement(
                    _NavItem2.default,
                    { eventKey: 6 },
                    'Kontakty'
                  )
                ),
                _react2.default.createElement(
                  _reactRouterBootstrap.LinkContainer,
                  { className: 'orange', to: '/prihlaska' },
                  _react2.default.createElement(
                    _NavItem2.default,
                    { eventKey: 7 },
                    'P\u0159ihl\xE1\u0161ka'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  { className: styles.fb },
                  _react2.default.createElement(
                    'a',
                    {
                      className: 'fb-link',
                      href: 'https://www.facebook.com/nenudimsecz',
                      target: '_blank'
                    },
                    _react2.default.createElement(
                      'svg',
                      {
                        version: '1.1',
                        id: 'Layer_1',
                        xmlns: 'http://www.w3.org/2000/svg',
                        xmlnsXlink: 'http://www.w3.org/1999/xlink',
                        x: '0px',
                        y: '0px',
                        viewBox: '0 0 291.319 291.319',
                        width: '32',
                        height: '32',
                        style: { enableBackground: 'new 0 0 291.319 291.319;' },
                        xmlSpace: 'preserve'
                      },
                      _react2.default.createElement(
                        'g',
                        null,
                        _react2.default.createElement('path', {
                          style: { fill: '#3B5998' },
                          d: 'M145.659,0c80.45,0,145.66,65.219,145.66,145.66c0,80.45-65.21,145.659-145.66,145.659 S0,226.109,0,145.66C0,65.219,65.21,0,145.659,0z'
                        }),
                        _react2.default.createElement('path', {
                          style: { fill: '#FFFFFF' },
                          d: 'M163.394,100.277h18.772v-27.73h-22.067v0.1c-26.738,0.947-32.218,15.977-32.701,31.763h-0.055 v13.847h-18.207v27.156h18.207v72.793h27.439v-72.793h22.477l4.342-27.156h-26.81v-8.366 C154.791,104.556,158.341,100.277,163.394,100.277z'
                        })
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'li',
                  { className: styles.fb },
                  _react2.default.createElement(
                    'a',
                    {
                      className: 'fb-link',
                      href: 'https://www.instagram.com/nenudimse/',
                      target: '_blank'
                    },
                    _react2.default.createElement(
                      'svg',
                      {
                        xmlns: 'http://www.w3.org/2000/svg',
                        width: '32',
                        height: '32',
                        xmlnsXlink: 'http://www.w3.org/1999/xlink',
                        viewBox: '0 0 132 132'
                      },
                      _react2.default.createElement(
                        'defs',
                        null,
                        _react2.default.createElement(
                          'linearGradient',
                          { id: 'b' },
                          _react2.default.createElement('stop', { offset: '0', stopColor: '#3771c8' }),
                          _react2.default.createElement('stop', { stopColor: '#3771c8', offset: '.128' }),
                          _react2.default.createElement('stop', {
                            offset: '1',
                            stopColor: '#60f',
                            stopOpacity: '0'
                          })
                        ),
                        _react2.default.createElement(
                          'linearGradient',
                          { id: 'a' },
                          _react2.default.createElement('stop', { offset: '0', stopColor: '#fd5' }),
                          _react2.default.createElement('stop', { offset: '.1', stopColor: '#fd5' }),
                          _react2.default.createElement('stop', { offset: '.5', stopColor: '#ff543e' }),
                          _react2.default.createElement('stop', { offset: '1', stopColor: '#c837ab' })
                        ),
                        _react2.default.createElement('radialGradient', {
                          id: 'c',
                          cx: '158.429',
                          cy: '578.088',
                          r: '65',
                          xlinkHref: '#a',
                          gradientUnits: 'userSpaceOnUse',
                          gradientTransform: 'matrix(0 -1.98198 1.8439 0 -1031.402 454.004)',
                          fx: '158.429',
                          fy: '578.088'
                        }),
                        _react2.default.createElement('radialGradient', {
                          id: 'd',
                          cx: '147.694',
                          cy: '473.455',
                          r: '65',
                          xlinkHref: '#b',
                          gradientUnits: 'userSpaceOnUse',
                          gradientTransform: 'matrix(.17394 .86872 -3.5818 .71718 1648.348 -458.493)',
                          fx: '147.694',
                          fy: '473.455'
                        })
                      ),
                      _react2.default.createElement('path', {
                        fill: 'url(#c)',
                        d: 'M65.03 0C37.888 0 29.95.028 28.407.156c-5.57.463-9.036 1.34-12.812 3.22-2.91 1.445-5.205 3.12-7.47 5.468C4 13.126 1.5 18.394.595 24.656c-.44 3.04-.568 3.66-.594 19.188-.01 5.176 0 11.988 0 21.125 0 27.12.03 35.05.16 36.59.45 5.42 1.3 8.83 3.1 12.56 3.44 7.14 10.01 12.5 17.75 14.5 2.68.69 5.64 1.07 9.44 1.25 1.61.07 18.02.12 34.44.12 16.42 0 32.84-.02 34.41-.1 4.4-.207 6.955-.55 9.78-1.28 7.79-2.01 14.24-7.29 17.75-14.53 1.765-3.64 2.66-7.18 3.065-12.317.088-1.12.125-18.977.125-36.81 0-17.836-.04-35.66-.128-36.78-.41-5.22-1.305-8.73-3.127-12.44-1.495-3.037-3.155-5.305-5.565-7.624C116.9 4 111.64 1.5 105.372.596 102.335.157 101.73.027 86.19 0H65.03z',
                        transform: 'translate(1.004 1)'
                      }),
                      _react2.default.createElement('path', {
                        fill: 'url(#d)',
                        d: 'M65.03 0C37.888 0 29.95.028 28.407.156c-5.57.463-9.036 1.34-12.812 3.22-2.91 1.445-5.205 3.12-7.47 5.468C4 13.126 1.5 18.394.595 24.656c-.44 3.04-.568 3.66-.594 19.188-.01 5.176 0 11.988 0 21.125 0 27.12.03 35.05.16 36.59.45 5.42 1.3 8.83 3.1 12.56 3.44 7.14 10.01 12.5 17.75 14.5 2.68.69 5.64 1.07 9.44 1.25 1.61.07 18.02.12 34.44.12 16.42 0 32.84-.02 34.41-.1 4.4-.207 6.955-.55 9.78-1.28 7.79-2.01 14.24-7.29 17.75-14.53 1.765-3.64 2.66-7.18 3.065-12.317.088-1.12.125-18.977.125-36.81 0-17.836-.04-35.66-.128-36.78-.41-5.22-1.305-8.73-3.127-12.44-1.495-3.037-3.155-5.305-5.565-7.624C116.9 4 111.64 1.5 105.372.596 102.335.157 101.73.027 86.19 0H65.03z',
                        transform: 'translate(1.004 1)'
                      }),
                      _react2.default.createElement('path', {
                        fill: '#fff',
                        d: 'M66.004 18c-13.036 0-14.672.057-19.792.29-5.11.234-8.598 1.043-11.65 2.23-3.157 1.226-5.835 2.866-8.503 5.535-2.67 2.668-4.31 5.346-5.54 8.502-1.19 3.053-2 6.542-2.23 11.65C18.06 51.327 18 52.964 18 66s.058 14.667.29 19.787c.235 5.11 1.044 8.598 2.23 11.65 1.227 3.157 2.867 5.835 5.536 8.503 2.667 2.67 5.345 4.314 8.5 5.54 3.054 1.187 6.543 1.996 11.652 2.23 5.12.233 6.755.29 19.79.29 13.037 0 14.668-.057 19.788-.29 5.11-.234 8.602-1.043 11.656-2.23 3.156-1.226 5.83-2.87 8.497-5.54 2.67-2.668 4.31-5.346 5.54-8.502 1.18-3.053 1.99-6.542 2.23-11.65.23-5.12.29-6.752.29-19.788 0-13.036-.06-14.672-.29-19.792-.24-5.11-1.05-8.598-2.23-11.65-1.23-3.157-2.87-5.835-5.54-8.503-2.67-2.67-5.34-4.31-8.5-5.535-3.06-1.187-6.55-1.996-11.66-2.23-5.12-.233-6.75-.29-19.79-.29zm-4.306 8.65c1.278-.002 2.704 0 4.306 0 12.816 0 14.335.046 19.396.276 4.68.214 7.22.996 8.912 1.653 2.24.87 3.837 1.91 5.516 3.59 1.68 1.68 2.72 3.28 3.592 5.52.657 1.69 1.44 4.23 1.653 8.91.23 5.06.28 6.58.28 19.39s-.05 14.33-.28 19.39c-.214 4.68-.996 7.22-1.653 8.91-.87 2.24-1.912 3.835-3.592 5.514-1.68 1.68-3.275 2.72-5.516 3.59-1.69.66-4.232 1.44-8.912 1.654-5.06.23-6.58.28-19.396.28-12.817 0-14.336-.05-19.396-.28-4.68-.216-7.22-.998-8.913-1.655-2.24-.87-3.84-1.91-5.52-3.59-1.68-1.68-2.72-3.276-3.592-5.517-.657-1.69-1.44-4.23-1.653-8.91-.23-5.06-.276-6.58-.276-19.398s.046-14.33.276-19.39c.214-4.68.996-7.22 1.653-8.912.87-2.24 1.912-3.84 3.592-5.52 1.68-1.68 3.28-2.72 5.52-3.592 1.692-.66 4.233-1.44 8.913-1.655 4.428-.2 6.144-.26 15.09-.27zm29.928 7.97c-3.18 0-5.76 2.577-5.76 5.758 0 3.18 2.58 5.76 5.76 5.76 3.18 0 5.76-2.58 5.76-5.76 0-3.18-2.58-5.76-5.76-5.76zm-25.622 6.73c-13.613 0-24.65 11.037-24.65 24.65 0 13.613 11.037 24.645 24.65 24.645C79.617 90.645 90.65 79.613 90.65 66S79.616 41.35 66.003 41.35zm0 8.65c8.836 0 16 7.163 16 16 0 8.836-7.164 16-16 16-8.837 0-16-7.164-16-16 0-8.837 7.163-16 16-16z'
                      })
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          this.props.children
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('container', styles.coffee) },
          _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('col-xs-12 col-sm-6', styles.claim) },
            _react2.default.createElement(
              'h3',
              null,
              'Jsme tu pro v\xE1s a va\u0161e d\u011Bti'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Novinky a nadch\xE1zej\xEDc\xED akce m\u016F\u017Eete sledovat na na\u0161\xED',
              " ",
              _react2.default.createElement(
                'a',
                { href: 'https://www.facebook.com/nenudimsecz/', target: '_blank' },
                'facebookov\xE9 str\xE1nce'
              ),
              '.'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-sm-6' },
            _react2.default.createElement(
              'div',
              { className: styles.card },
              _react2.default.createElement(
                'svg',
                {
                  xmlns: 'http://www.w3.org/2000/svg',
                  width: '160',
                  height: '40',
                  viewBox: '0 0 396 100'
                },
                _react2.default.createElement('rect', { width: '100', height: '100', fill: 'none' }),
                _react2.default.createElement(
                  'g',
                  { className: 'currentLayer' },
                  _react2.default.createElement('title', null),
                  _react2.default.createElement(
                    'g',
                    { className: 'selected' },
                    _react2.default.createElement('path', {
                      d: 'M224.2 26.7C224.2 28.9 224.2 29.7 224.3 28.6 224.4 27.4 224.4 25.6 224.3 24.6 224.2 23.5 224.2 24.5 224.2 26.7',
                      fill: '#393939'
                    }),
                    _react2.default.createElement('path', {
                      d: 'M234.5 20.9C234.5 21.7 234.6 22 234.7 21.6 234.8 21.2 234.8 20.6 234.7 20.2 234.6 19.8 234.5 20.1 234.5 20.9M224.1 21.5C224.1 22.4 224.2 22.7 224.3 22.2 224.4 21.7 224.4 21 224.3 20.6 224.2 20.2 224.1 20.6 224.1 21.5M101.8 45.9C101.8 47.9 101.8 48.7 101.9 47.8 102 46.9 102 45.2 101.9 44.2 101.8 43.1 101.8 43.9 101.8 45.9M155.7 44.3C155.7 45.2 155.8 45.5 155.9 45 156 44.5 156 43.8 155.9 43.4 155.8 43 155.7 43.4 155.7 44.3M234.9 59.9C235 61.6 235 62.3 235.1 61.4 235.2 60.4 235.2 59 235.1 58.2 235 57.4 234.9 58.1 234.9 59.9',
                      fill: '#5f5f5f'
                    }),
                    _react2.default.createElement('path', {
                      d: 'M222 0.3C216.4 2.1 217.4 10.5 223.1 10.5 223.8 10.5 223.9 11 224.1 17.7 224.6 30.5 224.6 31.4 223.5 31.1 206.6 26.3 192.8 37.4 192.8 55.8L192.8 58.8 194.1 58.5C195.8 58 199 58.7 200.4 59.9 204 62.9 204.3 66.6 201.4 73.4 201.2 74 201.6 74.3 203.8 75.3 209 77.8 216.3 77.3 222.6 74.1 226.2 72.2 226 72.2 226 73.4 226 78.2 234.2 80.6 238.5 76.9 242.3 73.7 241.1 66.4 236.4 64.5 234.8 63.8 234.9 64.9 234.7 36L234.5 10.6 236.5 10.4C241.4 9.9 242.6 2.7 238.1 1 237 0.5 223.1 0 222 0.3M253.5 8.3C242.6 18.2 241.6 20.4 246.4 22.9 249.9 24.8 251.1 24.1 260.4 15 263.2 12.2 263.6 10.4 261.5 8.2 258.9 5.3 256.8 5.4 253.5 8.3M6.8 27C1 29.1 0 36.6 5.1 39.1L6.8 39.9 6.8 53.7 6.8 67.5 4.8 68.2C1.6 69.3 0.2 73.1 2.1 75.5 4.6 78.7 18.6 78.3 21.2 75 22.9 72.8 22.2 69.9 19.4 68.3L17.6 67.2 17.6 53.4 17.6 39.6 19.5 38.8C28.9 34.6 33.4 42.1 33.1 61L33 67.5 30.7 68.6C28.2 69.8 27.6 70.5 27.6 72.7 27.6 77 35 78.8 44.6 76.8 50.5 75.5 50.9 68.7 45 67.9L43.3 67.6 43.3 59.7C43.4 36.7 37.2 26.3 24.1 27.1 21.8 27.3 17.9 28.2 16.2 29 15.4 29.3 15.1 29.3 14.3 28.6 12.3 26.7 9.4 26.1 6.8 27M101 27.3C95.7 29.8 95.2 37.6 100.3 39.3 101.8 39.8 102 40.5 101.8 46.5 101.8 49 101.7 54.8 101.7 59.3L101.6 67.5 99.7 68.2C96.5 69.3 95 73.5 97 75.7 99.7 78.6 113.1 78.2 116 75.1 117.9 73 117 69.7 114 68L112.4 67.1 112.4 53.4 112.4 39.8 114.3 38.8C122.9 34.7 127.7 41.2 128 57.6L128.1 61.3 129.4 60.1C131.1 58.7 134 58 136.2 58.5 137.1 58.7 138 58.9 138.1 58.9 139.1 58.9 137.6 45.6 136.1 40.5 132.9 29.4 124.3 24.8 113.3 28.3L109.9 29.3 108.9 28.3C106.8 26.3 103.8 25.9 101 27.3M176.2 26.9C168.3 28.1 167.3 34.7 174.5 37.3L175.6 37.7 175.6 44C175.4 60.5 172.4 66.5 164.4 66.5 158.2 66.5 155.5 57.9 155.9 40L156 36.9 157.4 36.9C162.6 36.9 164 30.3 159.2 27.9 157.9 27.3 148.2 27 144.4 27.5 138 28.4 137.5 37.2 143.8 37.8L145 37.9 145.3 45.1C146.1 67.4 152.7 77.5 165.8 76.8 179 76 185.3 66.4 185.9 45.7L186.2 37.2 188 36.5C192.8 34.6 192.9 29.7 188.1 27.6 186.1 26.7 179.6 26.3 176.2 26.9M250 27.7C244.1 29.7 243 37.4 248.3 39.8L249.3 40.3 249.1 51.9C248.9 58.3 248.8 64.3 248.8 65.3L248.8 67.2 247 67.6C242.1 68.9 241.1 74.3 245.3 76.6 248.5 78.2 260.7 77.9 263.8 76.2 267.5 74 266.3 68.8 261.8 67.6L260 67.1 260 50.9C260 33.1 259.9 31.8 257.7 29.2 255.7 26.9 253.6 26.4 250 27.7M64.9 27.8C52.5 30.9 45.6 45.9 49.6 61.1 53.3 75.1 64.3 81.3 76.6 76.2 78.9 75.3 80 74.5 84.2 71.2 85.5 70.1 85.6 70 86.6 70.7 92 74.2 95.6 67.3 90.9 62.5 82 53.7 73.3 55 77.4 64.5 78 66 73.3 68.9 70.3 68.9 64.1 68.9 59.4 64.1 58.6 57L58.3 54.6 67.5 54.3C82.6 53.8 84.1 53.7 85.1 53.1 86.5 52.1 87.6 49.5 87.6 46.8 87.7 34.1 76.7 24.9 64.9 27.8M288.2 28.2C286 29 284.4 29.8 283 31.1 282 32.1 281.9 32.1 281.5 31.4 280.1 28.9 276.3 27.6 272.7 28.4 266.2 29.9 265.6 38.6 272 39.2L273.9 39.4 274.2 44C274.8 52.5 274.2 68.6 273.4 69.1 269.5 71.3 268.8 75.8 272.1 77.5 273.5 78.2 284.2 78.3 286.4 77.5 290.2 76.3 289.9 69.3 286.1 69L284.7 68.8 284.9 57.8C285.1 46.9 285.3 45.1 286.7 42.1 288.8 37.2 295.7 37.4 297.9 42.4 298.9 44.7 299.6 52 299.6 59.5 299.6 68.1 299.6 68 297.3 69.5 294 71.6 294.1 74.2 297.4 76.7 298.9 77.8 308.4 78.1 311.1 77.1 315.9 75.2 315.5 70.1 310.3 67.9L309.2 67.4 309.3 57.5C309.5 44.9 310.5 41.1 314.1 39.1 319.5 36.2 322.4 43.1 323 59.7L323.3 67.5 321.8 68.3C319.5 69.5 318.4 71.1 318.4 73 318.4 76.6 320.3 77.7 327 78 336.3 78.4 339.1 76.9 338.9 71.9 338.8 70.6 335.7 67.3 334.6 67.3 333.7 67.3 333.4 65.9 333.3 61.3 333 48 330.5 37.6 326.2 32.5 321.5 26.8 313.7 26.4 307.3 31.6L305.1 33.3 303.6 31.8C300 28.3 293 26.6 288.2 28.2M74.2 37.6C75.8 38.7 77 40.6 77.4 42.7 77.8 44.4 77.4 44.5 67.3 44.8L59.1 45 60.4 42.6C63.3 36.8 69.8 34.5 74.2 37.6M219.1 40.3C220.2 40.7 221.7 41.5 222.5 42L224 43.1 224 52.5C224 63.4 224.3 62.7 219.5 64.9 210.3 69 203.3 65.3 202.9 56 202.4 45.1 210.4 37.4 219.1 40.3M125.4 68.5C119.8 70.8 122.1 76.7 128.9 77.5 131.1 77.7 131.1 77.9 129.8 75.5 129.2 74.5 128.3 72.4 127.8 71 126.8 68.1 126.6 68 125.4 68.5',
                      fill: '#626262'
                    }),
                    _react2.default.createElement('path', {
                      d: 'M192.6 79.8C190.1 83.1 183.6 88 179.3 89.7 177.7 90.3 177.7 90 179.8 93.3 183.4 98.9 187.8 100.2 193 97.1 199.9 93.1 200.8 88.8 196.2 81.5 193.9 77.7 194 77.8 192.6 79.8',
                      fill: '#f44336'
                    }),
                    _react2.default.createElement('path', {
                      d: 'M362.1 37.4L360.6 38.8 358.6 38.3C351.7 36.2 344.8 40.2 344.8 46.4 344.8 51.4 347.9 53.7 355.6 54.3 360.9 54.7 362.6 57.1 359.8 60.4 356.8 64 349.7 62.2 350.3 57.9 351 52.5 345.9 53.9 343.1 59.8 341 64.2 343 67.9 346.2 65.6 346.8 65.1 347.3 65.3 349.7 66.5 358.1 70.6 366.8 66.1 366.8 57.5 366.8 51.7 364.1 49.3 357.1 48.9 352.4 48.6 350.8 47.9 350.8 46.3 350.8 43.2 358.5 42.5 359.8 45.5 361.6 49.9 366.7 45.9 367.1 39.7 367.4 36.1 364.9 34.9 362.1 37.4M376.2 39C368.9 42.4 366.2 53.2 370.4 62 373.9 69.1 382.9 70.6 389.2 65 390.3 64 390.8 63.8 391.3 64.1 393.5 65.3 396.1 63.1 395.2 60.9 392.9 55.3 383.4 53.6 385.2 59.1 386.3 62.4 381.6 64 377.8 61.7 376.2 60.7 375.1 58.7 374.6 56L374.3 54.6 377.1 54.3C378.6 54.2 382 54.1 384.7 54.1 391.2 54.1 391.8 53.6 391.8 49.2 391.8 40.8 383.7 35.5 376.2 39M383.9 44.4C386.2 46.3 386.3 47.9 384.1 48.2 381.9 48.5 375.2 48.6 375.2 48.3 375.2 44.8 381.2 42.1 383.9 44.4M131.7 63.5C128.4 66.9 135.4 79.9 143.8 85.9 162.2 99 187.8 92.5 197.3 72.3 200.3 65.8 199.7 62.5 195.5 62.5 193.4 62.5 192.4 63.4 191.6 65.9 183.8 90.7 148.8 91.5 138.9 67.1 136.9 62.3 134.3 61 131.7 63.5',
                      fill: '#ffc107'
                    })
                  )
                )
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Tom\xE1\u0161 Krupka'
                ),
                _react2.default.createElement(
                  'a',
                  {
                    href: 'mailto:tomas.krupka@nenudimse.cz',
                    title: 'tomas.krupka@nenudimse.cz'
                  },
                  'tomas.krupka@nenudimse.cz'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  'a',
                  { href: 'tel:+420725085420', title: '+420 725 085 420' },
                  '+420 725 085 420'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('container', styles.footer) },
          _react2.default.createElement(
            'footer',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              '\xA9 ',
              new Date().getFullYear(),
              " ",
              _react2.default.createElement(
                'a',
                { href: 'https://www.nenudimse.cz', title: 'Nenud\xEDm se, z.s.' },
                'Nenud\xEDm se, z.s.'
              ),
              " ",
              _react2.default.createElement(
                'span',
                { className: styles.divider },
                '|'
              ),
              ' I\u010C 06978657',
              " ",
              _react2.default.createElement(
                'span',
                { className: styles.divider },
                '|'
              ),
              " ",
              _react2.default.createElement(
                'a',
                {
                  href: '/smluvni-podminky.pdf',
                  title: 'Smluvn\xED podm\xEDnky',
                  target: '_blank'
                },
                'Smluvn\xED podm\xEDnky'
              ),
              " ",
              _react2.default.createElement(
                'span',
                { className: styles.divider },
                '|'
              ),
              " ",
              _react2.default.createElement(
                'a',
                {
                  href: '/storno-podminky.pdf',
                  title: 'Storno podm\xEDnky',
                  target: '_blank'
                },
                'Storno podm\xEDnky'
              )
            )
          )
        )
      );
    }
  }]);
  return App;
}(_react.Component), _class.propTypes = {
  children: _react.PropTypes.object.isRequired,
  pushState: _react.PropTypes.func.isRequired
}, _class.contextTypes = {
  store: _react.PropTypes.object.isRequired
}, _temp);
exports.default = App;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.js
// module id = 1101
// module chunks = 0